export const getDistance = (latx, lonx, laty, lony) => {
  function toRad (Value) {
    return Value * Math.PI / 180
  }
  const R = 6371
  const dLat = toRad(+laty - +latx)
  const dLon = toRad(+lony - +lonx)
  const lat1 = toRad(+latx)
  const lat2 = toRad(+laty)

  const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2)

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
  return R * c
}
